import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import { useDispatch } from 'react-redux';
import PageHeader from '../../header';
import CenterPanel from './centerPanel';
import RightPanelOrTopPanel from './rightPanelOrTopPanel';
import AccordionSession from './accordion';
import BottomLogo from '../../../shared/bottom-logo/content.js';
import OrganisationalUnitAddUsersModal from './addUsersModal';
import ManageRolesForUsersModal from 'containers/OrganisationalUnitManageRolesForUsersModal';
import { previousPage } from 'actions/navigationBar';

import {
  selectOrgUnitId,
  getOrgUnitWithSearchTerm,
  updateOrganisationalUnitMemberSearch,
  getAvailableRoles,
} from '../../../../actions/organisation';
import { getOrganisationalUnitUsers } from '../../../../actions/user';

import { hideWhenClickAwayOrResize } from '../../../shared/contextualMenu/content';

export default function OrganisationalUnitManageUsersContent(props) {
  const dispatch = useDispatch();
  const [fetchingUserICanManage, setFetchingUserICanManage] = useState(false);

  useEffect(() => {
    window.addEventListener('click', (event) => hideWhenClickAwayOrResize('.waiting-area-view-one', event));
    window.addEventListener('resize', (event) => hideWhenClickAwayOrResize('.waiting-area-view-one', event));

    // Componnet mount
    let cb = () => {
      let cbForGetUsers = () => {
        setFetchingUserICanManage(false);
        dispatch(getAvailableRoles(props.id));
      };
      dispatch(getOrganisationalUnitUsers(props.id, cbForGetUsers));
    };
    setFetchingUserICanManage(true);
    dispatch(selectOrgUnitId(props.id));
    dispatch(getOrgUnitWithSearchTerm(props.id, cb));

    return () => {
      window.removeEventListener('click', (event) => hideWhenClickAwayOrResize('.waiting-area-view-one', event));
      window.removeEventListener('resize', (event) => hideWhenClickAwayOrResize('.waiting-area-view-one', event));
      dispatch(updateOrganisationalUnitMemberSearch(''));
    };
  }, []);

  const onSearchTermInputChange = (e) => {
    console.log('OrganisationalUnitManageUsersContent.onSearchTermInputChange: ', e);

    if (e.target != undefined) dispatch(updateOrganisationalUnitMemberSearch(e.target.value));
    else dispatch(updateOrganisationalUnitMemberSearch(e));
  };

  const isOrganisationalUnitLoaded = props.organisationalUnit && props.organisationalUnit.id > 0;
  const bottomSession = <AccordionSession organisationalUnit={props.organisationalUnit} userId={props.userId} />;

  const modals = (
    <div>
      {props.showManageRolesForOrgUsersModal && (
        <ManageRolesForUsersModal
          usersIcanManage={props.usersIcanManage}
          organisationalUnit={props.organisationalUnit}
          availableRoles={props.availableRoles}
        />
      )}
      {props.showOrganisationalUnitAddUsersModal && props.organisationalUnit && props.availableRoles && (
        <OrganisationalUnitAddUsersModal
          organisationalUnit={props.organisationalUnit}
          availableRoles={props.availableRoles}
          dispatch={dispatch}
        />
      )}
    </div>
  );

  return (
    <div>
      <div className="main-ui-container waiting-area-view-one new-waiting-area-view-one">
        <Container fluid as={Media} greaterThanOrEqual="computer" className="row">
          <div className="left-hand-side-panel">
            <div className="relative">
              <PageHeader
                classes="waiting-area-title"
                subHeaderClass="waiting-area-sub-title"
                title={APP.LANGUAGE.OrganisationalUnitManageUsers.PageHeaderTitle}
                subHeader={
                  props.organisationalUnit.name
                    ? APP.LANGUAGE.OrganisationalUnitManageUsers.PageSubHeaderTitle.replace(
                        '##organisationalUnitName##',
                        props.organisationalUnit.name.trim()
                      ).replace('##organisationAbbreviatedName##', props.organisationalUnit.abbreviatedName.trim())
                    : 'Loading...'
                }
                notRenderLogo={true}
                linkTo={`/organisational-unit/view-all`}
                linkText={APP.LANGUAGE.OrganisationalUnitManageUsers.BackToOrganisationalUnitLinkText}
                linkClass="back-to-org-link"
                linkOnClick={() => {
                  dispatch(previousPage(APP.LANGUAGE.OrganisationalUnitManageUsers.PageHeaderTitle));
                }}
                showLinkCondition={isOrganisationalUnitLoaded}
              >
                <span>
                  <img
                    className="ui image  mrrnull fl pdrs header-icon mrtsss"
                    src={APP.IMAGES.UserManagementOrgPageIcon.default}
                  />
                </span>
              </PageHeader>
            </div>
            <div className="manage-users-organisational-unit-container pdlm pdrm">
              <CenterPanel
                showManageRolesForOrgUsersModal={props.showManageRolesForOrgUsersModal}
                organisationalUnit={props.organisationalUnit}
                usersIcanManage={props.usersIcanManage}
                searchTerm={props.searchTerm}
                dispatch={dispatch}
                fetchingUserICanManage={fetchingUserICanManage}
                availableRoles={props.availableRoles}
                onSearchTermInputChange={(e) => onSearchTermInputChange(e)}
                timezone={props.timezone}
                isOnMobileOrTablet={false}
              />
            </div>
          </div>

          <div className="right-hand-side-panel color-right-hand-side-panel-bg">
            <RightPanelOrTopPanel
              organisationalUnit={props.organisationalUnit}
              availableRoles={props.availableRoles}
              dispatch={dispatch}
              bottomSession={bottomSession}
              usersIcanManage={props.usersIcanManage}
              fetchingUserICanManage={fetchingUserICanManage}
              selectedOrgUsersEmail={props.selectedOrgUsersEmail}
            />
          </div>
        </Container>
        <Container fluid as={Media} lessThan="computer">
          <div className="left-hand-side-panel-mobile">
            <PageHeader
              classes="waiting-area-title"
              subHeaderClass="waiting-area-sub-title"
              title={APP.LANGUAGE.OrganisationalUnitManageUsers.PageHeaderTitle}
              subHeader={
                props.organisationalUnit.name
                  ? APP.LANGUAGE.OrganisationalUnitManageUsers.PageSubHeaderTitle.replace(
                      '##organisationalUnitName##',
                      props.organisationalUnit.name.trim()
                    ).replace('##organisationAbbreviatedName##', props.organisationalUnit.abbreviatedName.trim())
                  : 'Loading...'
              }
              notRenderLogo={true}
              linkTo={`/organisational-unit/view-all`}
              linkText={APP.LANGUAGE.OrganisationalUnitManageUsers.BackToOrganisationalUnitLinkText}
              linkOnClick={() => {
                dispatch(previousPage(APP.LANGUAGE.OrganisationalUnitManageUsers.PageHeaderTitle));
              }}
              showLinkCondition={isOrganisationalUnitLoaded}
            >
              <span>
                <img
                  className="ui image  mrrnull fl pdrs header-icon mrtsss"
                  src={APP.IMAGES.UserManagementOrgPageIcon.default}
                />
              </span>
            </PageHeader>
            <div className="right-hand-side-panel-mobile">
              <RightPanelOrTopPanel
                organisationalUnit={props.organisationalUnit}
                availableRoles={props.availableRoles}
                dispatch={dispatch}
                bottomSession={bottomSession}
                usersIcanManage={props.usersIcanManage}
                fetchingUserICanManage={fetchingUserICanManage}
                selectedOrgUsersEmail={props.selectedOrgUsersEmail}
              />
            </div>
            <div className="pdlm pdrl">
              <CenterPanel
                showManageRolesForOrgUsersModal={props.showManageRolesForOrgUsersModal}
                organisationalUnit={props.organisationalUnit}
                usersIcanManage={props.usersIcanManage}
                searchTerm={props.searchTerm}
                dispatch={dispatch}
                fetchingUserICanManage={fetchingUserICanManage}
                availableRoles={props.availableRoles}
                onSearchTermInputChange={(e) => onSearchTermInputChange(e)}
                timezone={props.timezone}
                isOnMobileOrTablet={true}
              />
            </div>
            <div className="mrtl right-hand-side-bottom-on-mobile">
              {bottomSession}
              <BottomLogo />
            </div>
          </div>
        </Container>
        {modals}
      </div>
    </div>
  );
}

OrganisationalUnitManageUsersContent.propTypes = {
  id: PropTypes.number,
  organisationalUnit: PropTypes.object,
  usersIcanManage: PropTypes.array.isRequired,
  searchTerm: PropTypes.string,
  availableRoles: PropTypes.array,
  showOrganisationalUnitAddUsersModal: PropTypes.bool,
};
